/**
 * Print Layout
 * Minimal layout for print pages (no sidebar/navbar)
 * Still protected by authentication (route level)
 */

import { Outlet } from "react-router-dom";

export function PrintLayout() {
  return (
    <div className="h-screen w-screen overflow-auto bg-gray-100 dark:bg-gray-900">
      <Outlet />
    </div>
  );
}

